// Mega Menu Animation Script
document.addEventListener("DOMContentLoaded", function () {
  // Get elements
  const menuButton = document.querySelector(".search-menu__button");
  const mobileButton = document.querySelector(".mega-menu__button--search");
  const megaMenu = document.querySelector(".search-menu");
  const closeButton = document.querySelector(".search-menu__button--close");
  const backButton = document.querySelector(".search-menu__button--back");
  const closeText = document.querySelector(".search-menu__close-text");
  const megaMenuLogo = document.querySelector(".search-menu__logo");
  const navigationGrid = document.querySelector(".search-menu__navigation-grid");
  const chatbotColumn = document.querySelector(".search-menu__chatbot");
  const contactDetailsColumn = document.querySelector(".search-menu__contact-details");
  
  // New elements for staggered animations
  const contactDetailsHeading = document.querySelector(".search-menu__contact-details-headingxxx");
  const infoGroups = document.querySelectorAll(".search-menu__contact-details-contentxxx");
  const socialItems = document.querySelectorAll(".search-menu__socials-item");

  // Check if elements exist
  if (!menuButton || !megaMenu) {
    console.warn("Mega menu elements not found");
    return;
  }

  // Check if mobile
  const isMobile = () => window.innerWidth <= 1024;

  // Animation settings
  const SLIDE_DURATION = 0.6;
  const SLIDE_EASE = "power2.out";

  let isMenuOpen = false;
  let isAnimating = false;

  // Set initial states - mobile slides from right, desktop from top
  gsap.set(megaMenu, {
    top: isMobile() ? '100px' : "-100dvh",
    left: isMobile() ? "100%" : 0,
  });

  gsap.set(megaMenuLogo, {
    x: -100,
    opacity: 0,
  });

  gsap.set(closeButton, {
    x: 100,
    opacity: 0,
  });

  gsap.set(closeText, {
    x: 20,
    opacity: 0,
  });

  // Set initial states for new columns
  gsap.set(chatbotColumn, {
    y: isMobile() ? "0%" : "100%", // Mobile: no slide, Desktop: slide from bottom
    opacity: isMobile() ? 1 : 0, // Mobile: visible immediately, Desktop: fade in
  });

  gsap.set(contactDetailsColumn, {
    x: "100%",
    opacity: 0,
  });

  // Set initial states for contact details elements
  gsap.set(contactDetailsHeading, {
    opacity: 0,
    y: 20,
  });

  gsap.set(infoGroups, {
    opacity: 0,
    y: 20,
  });

  gsap.set(socialItems, {
    opacity: 0,
    y: 20,
  });

  // Mobile specific initial states
  if (isMobile()) {
    gsap.set(backButton, {
      x: 20,
      opacity: 0,
      visibility: "hidden",
    });
  }

  // Create main menu timeline
  const menuTimeline = gsap.timeline({
    paused: true,
    onComplete: function () {
      // Show columns when menu animation is complete
      showContentColumns();
    },
    onReverseComplete: function () {
      // Reset all elements to initial state
      gsap.set(
        [
          megaMenu,
          megaMenuLogo,
          closeButton,
          closeText,
          chatbotColumn,
          contactDetailsColumn,
          contactDetailsHeading,
          infoGroups,
          socialItems,
        ],
        {
          clearProps: "all",
        }
      );

      // Re-apply initial hidden states
      gsap.set(megaMenu, { 
        top: isMobile() ? '100px' : "-100dvh",
        left: isMobile() ? "100%" : 0,
      });
      gsap.set(megaMenuLogo, { x: -100, opacity: 0 });
      gsap.set(closeButton, { x: 100, opacity: 0 });
      gsap.set(closeText, { x: 20, opacity: 0 });
      gsap.set(chatbotColumn, { 
        y: isMobile() ? "0%" : "100%", 
        opacity: isMobile() ? 1 : 0 
      });
      gsap.set(contactDetailsColumn, { x: "100%", opacity: 0 });
      gsap.set(contactDetailsHeading, { opacity: 0, y: 20 });
      gsap.set(infoGroups, { opacity: 0, y: 20 });
      gsap.set(socialItems, { opacity: 0, y: 20 });

      // Mobile specific resets
      if (isMobile()) {
        gsap.set(backButton, { x: 20, opacity: 0, visibility: "hidden" });
      }

      // Reset tracking variables
      isAnimating = false;
    },
  });

  // Build animation sequence - different for mobile and desktop
  if (isMobile()) {
    // Mobile - slide from right
    menuTimeline.to(megaMenu, {
      left: 0,
      duration: SLIDE_DURATION,
      ease: SLIDE_EASE,
    });
  } else {
    // Desktop - slide from top
    menuTimeline.to(megaMenu, {
      top: 0,
      duration: 0.6,
      ease: "power2.inOut",
    });
  }

  // Show content columns function
  function showContentColumns() {
    // First animate contact details column from right
    gsap.to(contactDetailsColumn, {
      x: "0%",
      opacity: 1,
      duration: SLIDE_DURATION,
      ease: SLIDE_EASE,
      onComplete: function() {
        // After contact details column is in place, animate content and chatbot
        animateContactDetailsContent();
        
        // Animate chatbot column
        if (isMobile()) {
          // Mobile: no animation needed, already visible (opacity: 1)
          // Just ensure it's visible in case something changed it
          gsap.set(chatbotColumn, {
            opacity: 1
          });
        } else {
          // Desktop: slide from bottom and fade in
          gsap.to(chatbotColumn, {
            y: "0%",
            opacity: 1,
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
          });
        }
      }
    });
  }

  // Animate contact details content with stagger
  function animateContactDetailsContent() {
    // Create a timeline for sequential animations
    const contentTimeline = gsap.timeline();

    // Animate heading first
    contentTimeline.to(contactDetailsHeading, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power3.out",
    });

    // Then animate info groups with stagger
    contentTimeline.to(infoGroups, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: "power3.out",
      stagger: 0.05,
    }, "-=0.4");

    // Animate social items with stagger
    contentTimeline.to(socialItems, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.05,
      ease: "power2.out",
    }, "-=0.2");
  }

  // Hide content columns function
  function hideContentColumns(callback) {
    const hideTimeline = gsap.timeline({
      onComplete: function() {
        // Reset chatbot position after fade out
        gsap.set(chatbotColumn, { 
          y: isMobile() ? "0%" : "100%" 
        });
        if (callback) callback();
      }
    });

    // Slide out contact details column to the right (no need to animate infoGroups/socialItems)
    hideTimeline.to(contactDetailsColumn, {
      x: "100%",
      opacity: 0,
      duration: SLIDE_DURATION,
      ease: "power2.in",
    });

    // At the same time, fade out chatbot column (only on desktop, mobile stays visible)
    if (!isMobile()) {
      hideTimeline.to(chatbotColumn, {
        opacity: 0,
        duration: SLIDE_DURATION,
        ease: "power2.in",
      }, 0); // Start at the same time as contact details
    }
  }

  // Show back button (mobile)
  function showBackButton() {
    if (!isMobile()) return;

    gsap.to(backButton, {
      x: 0,
      opacity: 1,
      visibility: "visible",
      duration: SLIDE_DURATION,
      ease: SLIDE_EASE,
    });
  }

  // Hide back button (mobile)
  function hideBackButton() {
    if (!isMobile()) return;

    gsap.to(backButton, {
      x: 20,
      opacity: 0,
      duration: 0.4,
      ease: "power2.in",
      onComplete: () => {
        gsap.set(backButton, { visibility: "hidden" });
      },
    });
  }

  // Handle back button navigation
  function handleBackNavigation() {
    // Add your back navigation logic here
    hideBackButton();
  }

  // Open menu
  function openMenu() {
    if (isMenuOpen || isAnimating) return;

    isAnimating = true;
    isMenuOpen = true;
    menuButton.classList.add("active");
    document.body.classList.add("search-menu-open");
    menuTimeline.play();

    // Animate logo
    gsap.to(megaMenuLogo, {
      x: 0,
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
      delay: 0.6,
    });

    // Animate close button
    gsap.to(closeButton, {
      x: 0,
      opacity: 1,
      duration: 0.4,
      ease: "power2.out",
      delay: 0.8,
    });

    if (!isMobile()) {
      // Animate close text (desktop only)
      gsap.to(closeText, {
        x: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power3.out",
        delay: 1.2,
      });
    }

    // Reset animation flag after menu is fully open
    setTimeout(() => {
      isAnimating = false;
    }, 2000);
  }

  // Close menu with improved animation
  function closeMenu() {
    if (!isMenuOpen || isAnimating) return;

    isAnimating = true;
    isMenuOpen = false;
    menuButton.classList.remove("active");
    document.body.classList.remove("search-menu-open");

    // Create a closing timeline for better control
    const closeTimeline = gsap.timeline({
      onComplete: function() {
        // Reset animation flag when close animation is fully complete
        isAnimating = false;
      }
    });

    // First, hide the content columns and wait for completion
    hideContentColumns(() => {
      // After content columns are hidden, animate out close text
      closeTimeline.to(closeText, {
        opacity: 0,
        x: 20,
        duration: 0.3,
        ease: "power2.in",
      });

      // Animate out logo and buttons
      closeTimeline.to(
        [megaMenuLogo, closeButton],
        {
          x: function (i) {
            return i === 0 ? -100 : 100;
          },
          opacity: 0,
          duration: 0.3,
          ease: "power2.in",
        },
        "-=0.2"
      );

      // Finally, reverse the main menu timeline or slide out on mobile
      closeTimeline.call(() => {
        if (isMobile()) {
          // Mobile - slide out to right
          gsap.to(megaMenu, {
            left: "100%",
            duration: SLIDE_DURATION,
            ease: "power2.in",
            onComplete: () => {
              // Reset to initial state after animation
              gsap.set(megaMenu, {
                left: "100%",
                clearProps: "transform"
              });
            }
          });
        } else {
          // Desktop - reverse timeline
          menuTimeline.reverse();
        }
      });
    });
  }

  // Toggle menu
  function toggleMenu() {
    //console.log("toggleMenu");
    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // Event listeners
  menuButton.addEventListener("click", toggleMenu);
  mobileButton.addEventListener("click", toggleMenu);

  if (closeButton) {
    closeButton.addEventListener("click", closeMenu);
  }

  if (closeText) {
    closeText.addEventListener("click", closeMenu);
  }

  if (backButton) {
    backButton.addEventListener("click", handleBackNavigation);
  }

  // Escape key to close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isMenuOpen) {
      closeMenu();
    }
  });

  // Window resize handler
  window.addEventListener("resize", function () {
    // Reset menu on resize to prevent layout issues
    if (isMenuOpen) {
      //closeMenu();
    }
  });

  // Expose functions for coordination with mega menu
  window.searchMenuFunctions = {
    openMenu: openMenu,
    closeMenu: closeMenu,
    resetMenuState: function() {
      // Reset search menu to initial state without animations
      gsap.set(megaMenu, { 
        top: isMobile() ? '100px' : "-100dvh",
        left: isMobile() ? "100%" : 0,
        visibility: "visible"
      });
      gsap.set(megaMenuLogo, { x: -100, opacity: 0 });
      gsap.set(closeButton, { x: 100, opacity: 0 });
      gsap.set(closeText, { x: 20, opacity: 0 });
      gsap.set(chatbotColumn, { 
        y: isMobile() ? "0%" : "100%", 
        opacity: isMobile() ? 1 : 0 
      });
      gsap.set(contactDetailsColumn, { x: "100%", opacity: 0 });
      gsap.set(contactDetailsHeading, { opacity: 0, y: 20 });
      gsap.set(infoGroups, { opacity: 0, y: 20 });
      gsap.set(socialItems, { opacity: 0, y: 20 });
      
      if (isMobile()) {
        gsap.set(backButton, { x: 20, opacity: 0, visibility: "hidden" });
      }
      
      isMenuOpen = false;
      isAnimating = false;
      menuButton.classList.remove("active");
    }
  };

  // Remove this line - it automatically opens the menu
 // menuButton.click();
});